<p-toast position="top-right"></p-toast>

<p-dialog
	[(visible)]="visible"
	(visibleChange)="visibleChange.emit($event)"
	(onHide)="onHide()"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	header="Carga masiva de facturas"
	[style]="{ width: '840px' }"
	[breakpoints]="{ '960px': '95vw' }">

	<ng-template pTemplate="content">
		<div class="rf-wizard">
			<p class="modal-subtitle">Carga primero las <strong>referencias</strong> (Excel) y luego los <strong>archivos</strong> PDF/XML.</p>

			<div class="wizard-steps">
				<p-steps [model]="steps" [activeIndex]="activeStep" [readonly]="false" (activeIndexChange)="activeStep = $event"></p-steps>
			</div>

			<!-- ── Paso 1 · Referencias (Excel) ── -->
			<div class="rf-step-body" *ngIf="activeStep === 0">
				<div class="step-hint">
					<i class="fa-solid fa-circle-info"></i>
					<span>Descarga la plantilla, complétala y súbela. <strong>Cada columna trae un comentario</strong> que explica cómo llenarla. La columna <strong>Folio Fiscal</strong> se copia del nombre del archivo (ej. <code>A1198</code>); no abras el XML, el UID lo lee el sistema.</span>
				</div>

				<div class="upload-actions">
					<button pButton type="button" label="Descargar plantilla" icon="fa-solid fa-file-excel" class="p-button-outlined btn-excel" [loading]="downloadingTemplate" (click)="downloadTemplate()"></button>
					<input #excelInput type="file" accept=".xlsx" hidden (change)="onExcelSelected($event)" />
					<button pButton type="button" class="p-button-outlined file-pick" [class.has-file]="excelFile" [label]="excelFile ? excelFile.name : 'Seleccionar Excel (.xlsx)'" [icon]="excelFile ? 'fa-solid fa-file-excel' : 'fa-solid fa-paperclip'" (click)="excelInput.click()"></button>
					<button pButton type="button" label="Importar Excel" icon="fa-solid fa-upload" [loading]="importing" [disabled]="!excelFile" (click)="importExcel()"></button>
				</div>

				<div *ngIf="importing" class="loading-row">
					<p-progressSpinner styleClass="rf-spin" strokeWidth="4"></p-progressSpinner>
					<span>Procesando referencias…</span>
				</div>

				<div *ngIf="!importing && !importResult" class="inline-empty">
					<i class="fa-solid fa-table-list"></i>
					<span>Sube un Excel para ver el reporte de importación por fila.</span>
				</div>

				<ng-container *ngIf="importResult && !importing">
					<div class="stat-row">
						<div class="mini-stat is-green"><span class="mini-stat-icon"><i class="fa-solid fa-circle-plus"></i></span><div><div class="mini-stat-num">{{ importResult.created }}</div><div class="mini-stat-label">Creadas</div></div></div>
						<div class="mini-stat is-blue"><span class="mini-stat-icon"><i class="fa-solid fa-rotate"></i></span><div><div class="mini-stat-num">{{ importResult.updated }}</div><div class="mini-stat-label">Actualizadas</div></div></div>
						<div class="mini-stat" [ngClass]="importResult.errors ? 'is-red' : 'is-muted'"><span class="mini-stat-icon"><i class="fa-solid fa-triangle-exclamation"></i></span><div><div class="mini-stat-num">{{ importResult.errors }}</div><div class="mini-stat-label">Errores</div></div></div>
					</div>
					<div class="rf-table-wrap">
						<p-table [value]="importResult.rows" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="280px" [paginator]="importResult.rows.length > 25" [rows]="25">
							<ng-template pTemplate="header">
								<tr><th>Fila</th><th>Folio</th><th>Folio Fiscal</th><th>Tipo</th><th>Mes</th><th>Estado</th><th>Mensaje</th></tr>
							</ng-template>
							<ng-template pTemplate="body" let-r>
								<tr>
									<td>{{ r.rowNumber }}</td><td>{{ r.folio || '—' }}</td><td class="rf-uid">{{ r.folioFiscal || '—' }}</td>
									<td>{{ r.tipo || '—' }}</td><td>{{ r.mes || '—' }}</td>
									<td><p-tag [severity]="statusSeverity(r.status)" [value]="r.status"></p-tag></td><td>{{ r.message }}</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</ng-container>
			</div>

			<!-- ── Paso 2 · Archivos (PDF / XML) ── -->
			<div class="rf-step-body" *ngIf="activeStep === 1">
				<div class="step-hint">
					<i class="fa-solid fa-circle-info"></i>
					<span>Sube los archivos <strong>tal como se descargan</strong> del portal (no los renombres). Se emparejan PDF+XML por nombre y el UID se lee del XML. Hasta ~200 facturas por lote.</span>
				</div>

				<label class="dropzone dropzone-lg" [class.is-dragging]="isDraggingFiles" [class.has-file]="selectedFiles.length"
					(dragover)="onFilesDragOver($event)" (dragleave)="onFilesDragLeave($event)" (drop)="onFilesDrop($event)">
					<i class="fa-solid fa-cloud-arrow-up"></i>
					<span class="dropzone-title">{{ selectedFiles.length ? (selectedFiles.length + ' archivo(s) seleccionado(s)') : 'Arrastra o selecciona los PDF / XML' }}</span>
					<span class="dropzone-hint">.pdf y .xml · tal como se descargan (no renombres)</span>
					<input type="file" accept=".pdf,.xml" multiple (change)="onFilesSelected($event)" hidden />
				</label>

				<div class="action-row action-row-end">
					<button pButton type="button" label="Cargar archivos" icon="fa-solid fa-cloud-arrow-up" [loading]="uploading" [disabled]="!selectedFiles.length" (click)="uploadFiles()"></button>
				</div>

				<div *ngIf="uploading" class="loading-row">
					<p-progressSpinner styleClass="rf-spin" strokeWidth="4"></p-progressSpinner>
					<span>Subiendo y ligando archivos…</span>
				</div>

				<div *ngIf="!uploading && !uploadResult" class="inline-empty">
					<i class="fa-solid fa-cloud-arrow-up"></i>
					<span>Selecciona los PDF/XML para ver el reporte de carga.</span>
				</div>

				<ng-container *ngIf="uploadResult && !uploading">
					<div class="stat-row">
						<div class="mini-stat is-green"><span class="mini-stat-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span><div><div class="mini-stat-num">{{ uploadResult.uploaded }}</div><div class="mini-stat-label">Subidos</div></div></div>
						<div class="mini-stat is-blue"><span class="mini-stat-icon"><i class="fa-solid fa-link"></i></span><div><div class="mini-stat-num">{{ uploadResult.matchedInvoices }}</div><div class="mini-stat-label">Ligadas</div></div></div>
						<div class="mini-stat" [ngClass]="uploadResult.skippedUnmatched.length ? 'is-amber' : 'is-muted'"><span class="mini-stat-icon"><i class="fa-solid fa-circle-question"></i></span><div><div class="mini-stat-num">{{ uploadResult.skippedUnmatched.length }}</div><div class="mini-stat-label">Sin coincidencia</div></div></div>
						<div class="mini-stat" [ngClass]="uploadResult.errors.length ? 'is-red' : 'is-muted'"><span class="mini-stat-icon"><i class="fa-solid fa-triangle-exclamation"></i></span><div><div class="mini-stat-num">{{ uploadResult.errors.length }}</div><div class="mini-stat-label">Errores</div></div></div>
					</div>
					<div class="rf-table-wrap">
						<p-table [value]="uploadResult.results" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="280px" [paginator]="uploadResult.results.length > 25" [rows]="25">
							<ng-template pTemplate="header">
								<tr><th>Archivo</th><th>Folio Fiscal</th><th>Tipo</th><th>Estado</th><th>Mensaje</th></tr>
							</ng-template>
							<ng-template pTemplate="body" let-r>
								<tr>
									<td>{{ r.fileName }}</td><td class="rf-uid">{{ r.folioFiscal || '—' }}</td>
									<td>{{ r.kind }} <p-tag *ngIf="r.docType === 'complement'" severity="help" value="REP" styleClass="ml-1"></p-tag></td>
									<td><p-tag [severity]="statusSeverity(r.status)" [value]="r.status"></p-tag></td><td>{{ r.message }}</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton type="button" label="Cerrar" class="p-button-text" (click)="close()" *ngIf="!(activeStep === steps.length - 1 && uploadResult)"></button>
		<button pButton type="button" label="Anterior" icon="pi pi-chevron-left" class="p-button-outlined" *ngIf="activeStep > 0" (click)="activeStep = activeStep - 1"></button>
		<button pButton type="button" label="Siguiente" icon="pi pi-chevron-right" iconPos="right" *ngIf="activeStep < steps.length - 1" (click)="activeStep = activeStep + 1"></button>
		<button pButton type="button" label="Finalizar" icon="pi pi-check" iconPos="right" class="p-button-success" *ngIf="activeStep === steps.length - 1 && uploadResult" (click)="finish()"></button>
	</ng-template>
</p-dialog>
